import { useState } from "react";
import TextInput from "../../../../components/TextInput";
import { toast } from "../../../../components/toastNotification";
import SaveButton from "../../../../components/SaveButton";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import useAddEmailRecipient from "./hooks/useAddEmailRecipient";
import useEmailRecipient from "./hooks/useEmailRecipient";
import { useRecoilState, useRecoilValue } from "recoil";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { addStateEmailRecipient } from "./atoms/atoms";
import MultiSelectInput from "../../../../components/MultiSelectInput";
import useGetModules from "./hooks/useGetModules";
import useOperations from "./hooks/useOperations";
import useFieldsOwned from "./hooks/useFieldsOwned";
import CancelButton from "../../../../components/CancelButton";

const AddEmailRecipientForm = () => {
  //Hooks
  const AddEmailRecipient = useAddEmailRecipient();
  const data = useEmailRecipient();
  const modules = useGetModules();
  //Recoils Call
  const [actionAddState, setActionAddState] = useRecoilState(
    addStateEmailRecipient
  );
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasEmailRecipient, setHasEmailRecipient] = useState(false);
  const userAccount = useRecoilValue(accountAtom);

  const defaulValues = {
    autoEmailNotificationId: 0,
    recipientEmail: "",
    updatedBy: "",
    updatedOn: null,
    isActive: true,
    createdOn: null,
    createdBy: "",
    operationIds: [],
    fieldIds: [],
    moduleIds: [],
  };
  const [newEmailRecipient] = useState([defaulValues]);
  const [EmailRecipientExist, setEmailRecipientExist] = useState(false);
  const { data: operationsTypeQuery } = useOperations();
  const { data: fieldsTypeQuery } = useFieldsOwned();
  const dropDownFields =
    fieldsTypeQuery &&
    fieldsTypeQuery.map((m) => {
      return { label: m.fieldName, value: m.fieldId };
    });
  const operationsType =
    operationsTypeQuery &&
    operationsTypeQuery
      .filter((c) => c.isActive === true)
      .map((x) => {
        return { value: x.operationId, label: x.operationName };
      });
  const handleAddEmailRecipient = (SourceType, fieldName, inputvalue) => {
    setChanged(true);
    setEmailRecipientExist(false);

    if (SourceType === "addEmailRecipient") {
      if (fieldName === "recipientEmail") {
        inputvalue = inputvalue.trim();
        const result = data.data.filter(
          (item) =>
            item.recipientEmail.toUpperCase() === inputvalue.toUpperCase()
        )[0];
        if (result !== undefined) {
          newEmailRecipient.map((x) => (x.recipientEmail = ""));
          setEmailRecipientExist(true);
        } else {
          newEmailRecipient.map((x) => (x.recipientEmail = inputvalue));
        }
      }
      if (fieldName === "operationsType") {
        newEmailRecipient.map((x) =>
          inputvalue != null
            ? (x.operationId = inputvalue)
            : (x.operationId = 0)
        );
      }
    }
    newEmailRecipient.map((x) => (x.createdBy = userAccount.userName));
    newEmailRecipient.map((x) =>
      x.recipientEmail !== ""
        ? setHasEmailRecipient(true)
        : setHasEmailRecipient(false)
    );
  };
  const handleMultiSelectFieldsOwned = (checkedFields) => {
    const fields = [];
    checkedFields.forEach((m) => {
      fields.push(m.value);
    });
    newEmailRecipient.map((x) => (x.fieldIds = fields));
  };
  const handleMultiSelectOperations = (checkedOps) => {
    const ops = [];
    checkedOps.forEach((m) => {
      ops.push(m.value);
    });
    newEmailRecipient.map((x) => (x.operationIds = ops));
  };

  const handleMultiSelectModule = (checkedModules) => {
    const module = [];
    checkedModules.forEach((m) => {
      module.push(m.value);
    });
    newEmailRecipient.map((x) => (x.moduleIds = module));
    newEmailRecipient.map((x) => (x.isActive = true));
    newEmailRecipient.map((x) =>
      x.recipientEmail !== ""
        ? setHasEmailRecipient(true)
        : setHasEmailRecipient(false)
    );
  };

  const dropDownModules = modules.map((m) => {
    return { label: m.moduleName, value: m.id };
  });

  //save changes
  const handleSave = (newEmailRecipient) => {
    if (changed) {
      if (!EmailRecipientExist) {
        if (newEmailRecipient.filter((x) => x.recipientEmail) !== "") {
          //call Insert
          AddEmailRecipient(newEmailRecipient);
          setActionAddState(!actionAddState);
          setOpenModal(false);
        } else {
          toast.fire("Saving Failed", "Please populate fields!", "error");
          setOpenModal(false);
        }
      } else {
        toast.fire("Saving Failed", "The data already exists!", "error");
        setOpenModal(false);
      }
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setOpenModal(false);
    }
  };
  const validate = (text) => {
    const reg = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    if (reg.test(text) === false) {
      return false;
    } else {
      return true;
    }
  };
  // end of saving changes
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: "#fff",
      borderColor: "#edebeb",
      minHeight: "28px",
      //   height: "9px",
      boxShadow: state.isFocused ? null : null,
      fontSize: "12px",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "28px",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  const matcolumns = [
    {
      title: (
        <div>
          Recipient Email <span className="requiredAsterisk">*</span>
        </div>
      ),
      field: "recipientEmail",
      render: (rowData) => {
        return (
          <div className="w-full ">
            <div className="">
              <TextInput
                defaultValue={rowData.recipientEmail}
                onChange={(e) =>
                  handleAddEmailRecipient(
                    "addEmailRecipient",
                    "recipientEmail",
                    e.target.value
                  )
                }
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Operations Group",
      field: "operation",
      render: (rowData) => {
        return (
          <div className="w-full ">
            <div className="">
              <MultiSelectInput
                menuPortalTarget={document.body}
                styles={customStyles}
                isMulti
                closeMenuOnSelect={false}
                options={operationsType}
                className="basic-multi-select"
                classNamePrefix="select"
                handleMultiSelect={handleMultiSelectOperations}
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Fields Owned",
      field: "fieldsOwned",
      render: (rowData) => {
        return (
          <div className="w-full">
            <div className="w-full">
              <MultiSelectInput
                menuPortalTarget={document.body}
                styles={customStyles}
                isMulti
                closeMenuOnSelect={false}
                options={dropDownFields}
                className="basic-multi-select"
                classNamePrefix="select"
                handleMultiSelect={handleMultiSelectFieldsOwned}
              />
            </div>
          </div>
        );
      },
    },
    {
      title: "Module",
      field: "module",
      render: (rowData) => {
        return (
          <div className="w-full">
            <div className="w-full">
              <MultiSelectInput
                menuPortalTarget={document.body}
                styles={customStyles}
                isMulti
                closeMenuOnSelect={false}
                options={dropDownModules}
                className="basic-multi-select"
                classNamePrefix="select"
                handleMultiSelect={handleMultiSelectModule}
              />
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="">
      <div className="w-full ">
        <ConfirmBoxModal
          ModalTitle="Add Email Recipient"
          qConfirmation=" Are you sure you want to add this?"
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave(newEmailRecipient);
          }}
        />
        <div className="p-3 space-y-2 border-l-2 border-primary box-shadow">
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="text-base text-primary font-bold pl-3">
                Add New Email Recipient
              </div>
              <div className="flex items-center space-x-2 mx-3">
                <SaveButton
                  className={`flex justify-center shadow-md text-xs font-semibold text-white justify-left gap-x-1 rounded-full bg-senary hover:bg-senary px-3  py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
                  ${!hasEmailRecipient ? "opacity-50" : "opactiy-100"}`}
                  disabled={!hasEmailRecipient}
                  onClick={() => {
                    const validEmail = validate(
                      newEmailRecipient[0].recipientEmail
                    );
                    if (validEmail) {
                      setOpenModal(true);
                    } else {
                      toast.fire(
                        "Saving Failed",
                        "Email is Invalid!",
                        "warning"
                      );
                    }
                  }}
                />
                <CancelButton
                  className="flex items-left text-xs shadow-md font-semibold text-white justify-left gap-x-1 rounded-full bg-octonary  hover:bg-octonary px-2 py-1  "
                  onClick={() => setActionAddState(!actionAddState)}
                />
              </div>
            </div>
            <div className="mr-3 ml-3 border-b-2 border-secondary"></div>
          </div>
          <div className="py-2 pt-3 pr-3 pl-3">
            <MaterialExTable
              columns={matcolumns}
              data={newEmailRecipient}
              paging={false}
            />
          </div>
        </div>
        <div className="hidden sm:block" aria-hidden="true">
          <div className=""></div>
        </div>
      </div>
    </div>
  );
};

export default AddEmailRecipientForm;
